module.exports = __webpack_public_path__ + "ssrs.png?caef521e28e77a19969db7cd817b2eb2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssrs.png
// module id = 622
// module chunks = 0